import React, { memo } from 'react';
import VirtualList from '@creditflowresearch/uilib/VirtualList';
import useGetPositions from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';
import FieldRow from './FieldRow';
import FieldItem from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/FieldItem/FieldItem';

const ReviewUnknownsField = (props) => (
  <FieldItem { ...props }>
    { FieldRow }
  </FieldItem>
);

const ReviewUnknownsFieldsList = () => {
  const { positions } = useGetPositions();

  return (
    <VirtualList
      data={ positions }
      itemKey="localId"
      height={ 600 }
      itemSize={ 46 }
    >
      { ReviewUnknownsField }
    </VirtualList>
  );
};

export default memo(ReviewUnknownsFieldsList);
